export default [
    {
      name: "monkey",
      type: "gltfModel",
      path: "./model/monkey.glb",
    },
    {
        name: "icosahedron",
        type: "gltfModel",
        path: "./model/icosahedron.glb",
      },
      {
        name: "heart",
        type: "gltfModel",
        path: "./model/heart.glb",
      }
  ]; 